import { AddEditDocumentDialog, AddEditDocumentDialogState } from "components/Document";
import { UserSelectDialog } from "components/UserSelectDialog";
import { Dispatch, SetStateAction } from "react";

type WorkDetailDialogsProps = {
  tenantId: string;
  assignStepId: string | null;
  setAssignStepId: (activityId: string | null) => void;
  onAssign: (activityId: string, userId: string) => Promise<void>;
  documentDialog: AddEditDocumentDialogState;
  setDocumentDialog: Dispatch<SetStateAction<AddEditDocumentDialogState>>;
  onDocumentSubmit: (documentId: string, activityId?: string) => void;
};

/**
 * The two overlays the detail screen can raise: assigning a step to a user, and
 * adding a document. One document dialog serves both attach flows — with an
 * activityId it attaches to that step (the dialog creates the ActivityDocument
 * itself), without one the caller attaches at the workflow level.
 */
export function WorkDetailDialogs({
  tenantId,
  assignStepId,
  setAssignStepId,
  onAssign,
  documentDialog,
  setDocumentDialog,
  onDocumentSubmit,
}: WorkDetailDialogsProps) {
  return (
    <>
      <UserSelectDialog
        open={assignStepId !== null}
        title="Assign step to"
        onClose={() => setAssignStepId(null)}
        onSelect={async (userId) => {
          if (assignStepId) {
            await onAssign(assignStepId, userId);
          }
          setAssignStepId(null);
        }}
      />
      {documentDialog.open && (
        <AddEditDocumentDialog
          dialogState={documentDialog}
          setDialogState={setDocumentDialog}
          tenantId={tenantId}
          generateTitleOnCreate={true}
          onSubmit={(document, dialogState) =>
            onDocumentSubmit(document.id, dialogState.activityId)
          }
        />
      )}
    </>
  );
}
